import axios from "axios"

export const getDocuments = async (params = {}) => {
  return await axios.get("/documentations/documentations/", { params })
}

export const uploadDocument = async (payload = {}) => {
  return await axios.post(`/documentations/upload/`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    formSerializer: {
      indexes: true,
    },
  })
}

export const extractDocument = async id => {
  return await axios.post(`/documentations/documentations/${id}/extract/`)
}

export const extractMultiDocument = async payload => {
  return await axios.post(`/documentations/extract/`, payload)
}

export const updateDocument = async (id, payload) => {
  return await axios.patch(`/documentations/documentations/${id}/`, payload)
}

export const deleteDocument = async id => {
  return await axios.delete(`/documentations/documentations/${id}/`)
}
